module.exports = __webpack_public_path__ + "img/companyinfo-active.fdf0a452.png";